import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { dateString } from 'shared/utils';
import { useRequest } from 'shared/hooks';
import { getUnitPath } from 'shared/routes/building';
import { formatUnitName } from 'shared/utils/formatters';
import { getTenantLocationHistory } from 'shared/api/tenants';
import { CardControls, CardSection } from 'shared/components/cardControls';
import StickyHeadTable from 'shared/components/table/StickyHeadTable';
import { Section } from 'shared/components/styled/layouts';

// Assumes the last row is the earliest record.
function getOperation(row, _, index, allRows) {
  let action;
  if (index === allRows.length - 1) {
    action = 'created';
  } else if (!row.unit_id) {
    action = 'archived';
  } else if (row.unit_id && allRows[index + 1].unit_id === null) {
    // This row has a unit_id, previous row doesn't have a unit_id.
    action = 'unarchived';
  } else {
    action = 'moved';
  }

  return row.created_by ? `tenant ${action} by ${row.created_by}` : `tenant ${action}`;
}

const columns = [
  {
    name: 'Location',
    formatter: (row) => (
      row.unit_id
        ? <Link to={getUnitPath(row.building_id, row.unit_id)}>{`${row.address_1}, ${formatUnitName(row.unit_name)}`}</Link>
        : ''
    ),
  },
  {
    name: 'Operation',
    formatter: getOperation,
  },
  {
    name: 'Date',
    formatter: (row) => dateString(row.created_at),
  },
];

/**
 * @param {Object} props
 * @param {Object} props.tenantState - Tenant state object
 */
export default function TenantLocationHistory({ tenantState: { data: { id: tenantId } } }) {
  const { request, isLoading } = useRequest();
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    (async () => {
      const result = await request(getTenantLocationHistory(tenantId));
      if (!result) return;
      setLocations(result);
    })();
  }, [request, tenantId]);

  return (
    <CardSection>
      <CardControls editEnabled={false} />
      <Section>
        <StickyHeadTable
          columns={columns}
          isLoading={isLoading}
          noRowsText="No history"
          rowId="created_at"
          rows={locations}
          striped
        />
      </Section>
    </CardSection>
  );
}
